import * as React from "react";
import { useCallback, useState } from "react";
import { Row, Col } from "components/bootstrap";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import { ErrorsProvider } from "components/lookup-tables/contexts/ErrorsContext";
import ErrorsConsumer from "components/lookup-tables/lookup-table-list/errors-consumer";
import { useFetchDataAdapters } from "components/lookup-tables/hooks/useLookupTablesAPI";
import { adapterListElements } from "./constants";
import columnRenderers from "./column-renderers";
import useActions from "./use-actions";
const queryHelpComponent = /* @__PURE__ */ React.createElement(
  QueryHelper,
  {
    entityName: "data adapter",
    commonFields: ["id", "title", "name", "description"],
    example: /* @__PURE__ */ React.createElement("p", null, "searching without a field name matches against the ", /* @__PURE__ */ React.createElement("code", null, "title"), " field:", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, "geoip"), " ", /* @__PURE__ */ React.createElement("br", null), "is the same as", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, "title:geoip"))
  }
);
function DataAdapterList() {
  const [{ adapterNames }, setNames] = useState({ adapterNames: void 0 });
  const { fetchPaginatedDataAdapters, dataAdaptersKeyFn } = useFetchDataAdapters();
  const { renderActions } = useActions();
  const handleFetchAdapters = useCallback(
    async (searchParams) => {
      var _a;
      const resp = await fetchPaginatedDataAdapters(searchParams);
      const overrides = {
        title: { sortable: true },
        name: { sortable: true },
        description: { sortable: false }
      };
      const expectedIds = adapterListElements.defaultLayout.defaultDisplayedAttributes;
      const attrMap = /* @__PURE__ */ new Map();
      ((_a = resp.attributes) != null ? _a : []).forEach((attr) => {
        var _a2;
        const override = (_a2 = overrides[attr.id]) != null ? _a2 : {};
        attrMap.set(attr.id, { ...attr, ...override });
      });
      expectedIds.forEach((id) => {
        var _a2;
        if (!attrMap.has(id)) {
          const override = (_a2 = overrides[id]) != null ? _a2 : {};
          attrMap.set(id, {
            id,
            title: id.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
            type: "STRING",
            ...override
          });
        }
      });
      setNames({
        adapterNames: resp.list.map((adapter) => adapter.name)
      });
      return Promise.resolve({
        ...resp,
        attributes: Array.from(attrMap.values())
      });
    },
    [fetchPaginatedDataAdapters]
  );
  return /* @__PURE__ */ React.createElement(ErrorsProvider, null, /* @__PURE__ */ React.createElement(ErrorsConsumer, { adapterNames }), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "data adapter",
      entityActions: renderActions,
      queryHelpComponent,
      tableLayout: adapterListElements.defaultLayout,
      fetchEntities: handleFetchAdapters,
      keyFn: dataAdaptersKeyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers
    }
  ))));
}
export default DataAdapterList;
